// import {getList} from '@/api/base_request'
import store from '../../store'
import {siteProtocol} from '../../api/site'

export default {
  'entityName': 'user',
  "title": "User",
  'pagination': {
    'rowsPerPage': 10,
    'page': 1,
    'sortBy': 'id',
    'descending': true
  },
  'fields': [
   
  {
      slim:true,
      value: 'protocol_id',
      text: 'Protocol',
      title:"name",
      'type': 'autocomplete',
      'table': {
        'sortable': true,
        'filter': true
      },
      readonly:true,
      filter: (item, search) => {
        if (search) return [{'protocol.name': `%${search}%`}]
      },
      render : (v) => {
        return v.protocol.name
      },
      'validators': [
        'required',
      ]
    },
   
    {
      slim:true,
      value: 'protocol_roles_id',
      reference:'protocol_roles',
      text: 'User profile',
      title: "name",
      id:'id',
      subtitle: item => `${item.group_name}`,
      'type': 'autocomplete',      
      'validators': [
        'required'
      ],
      render: item => { return item.protocol_roles && item.protocol_roles.name },
      filter: (item) => { return { 'protocol_id': item.protocol_id } },
      // readonly: item => item.status != 'New'
      readonly: item => item.status == 'Removed' || item.status == 'New'
      //issue vari miletto
      ,changed: () => { 

        //ISSUE 246
        //window.synchroles = true
        store.dispatch("app/ACT_windowsynchroles", true);
        //ISSUE 246

      }
      //issue vari miletto
    },
   
    {
      slim:true,
      value: 'first_name',
      text: 'First name',
      'type': 'text',
      'table': {
        'sortable': true,
        'filter': true
      },
      render: (item) => { return item.first_name + ' ' + item.last_name },
      filter: (item, search) => {
        if (search) return {ww: [{'first_name': `%${search}%`}, {'last_name': `%${search}%`}]}
      },
      'validators': [
        'required',
      ],
      readonly: item => item.status != 'To Activate'
    },

    {
      slim:true,
      value: 'last_name',
      text: 'Last name',
      'type': 'text',
      'validators': [
        'required',
      ],
      readonly: item => item.status != 'To Activate'
    },
    
    {
      small:true,
      value: 'username',
      text: 'Username',
      'type': 'text',   
      'validators': [
        'required',
      ],
      'table': {
        'sortable': true,
        'filter': true
      },
      readonly: item => item.status != 'To Activate'
    },
    {
      slim: true,
      value: 'email',
      text: 'Email',
      'table': {
        'sortable': true,
        'filter': true
      },
      'type': 'text',
      'validators': [
        'required',
        //ISSUE 266
        'email',
        'emaillen'
        //ISSUE 266
      ],
      // readonly: item => item.status != 'New'
      readonly: item => item.status != 'To Activate'
    },
    {
      mini:true,
      value: 'phone',
      text: 'Phone',
      type: 'text',
      default: null,
      validators: [ 
      //  'required'        
      ],
      readonly: item => item.status != 'To Activate'
    },
    {
      slim:true,
      value: 'city',
      text: 'City',
      'type': 'text',
      'validators': [
        /*'required',*/ //issue 220
      ],
      readonly: item => item.status != 'To Activate'
    },  
    {
      middle:true,
      value: 'sites',
      text: 'Sites',
      title:"factor_label",
      multiple:true,
      return_object:true,
      deletable_chips:true,
      chips:true,
      'type': 'autocomplete',
      readonly: item => item.status == 'Removed' || item.status == 'New' || item.status == 'Active', //issue 210, su active deve essere disabilitato
      list: siteProtocol
      //issue vari miletto
      ,changed: () => { 
        //console.log('sites changed',dosynch) 

        //ISSUE 246
        //window.synchsites = true
        store.dispatch("app/ACT_windowsynchsites", true);
        //ISSUE 246

      }
      //issue vari miletto
    },
{
      slim:true,
      value: "platforms",
      text: "Platforms",
      append_icon: '',
      multiple: true,
      chips: true,
      deletable_chips:true,
      list:['REDCap', 'eCDS', 'SafetyDB'],
      placeholder: '',
      loadRemote: false,
      type: "list",
      'table': {
        'sortable': true,
        'filter': true
      },
      render: (item) => { return item.platforms.join(',') },
      readonly: item => item.status != 'To Activate'
    },
    {
      slim:true,
      value: 'status',
      text: 'Status',
      'type': 'list',
      'table': {
        'sortable': true,
        'filter': true
      },
      'list': item => item.status == 'Removed' ? ['New', 'To Activate', 'Active', 'Removed'] : ['New', 'To Activate', 'Active'],
      'validators': [
        'required'
      ],
      //readonly: item => item.status == 'Removed' || store.getters.role != 'Administrator' //issue 233
      readonly: () => store.getters.role != 'Administrator' //issue 233
    },


    {
      full:true,
      value: 'comment',
      text: 'Comments',
      'type': 'textarea',
      readonly: item => item.status == 'Removed'
    },

  ],
  actions: [
    { "value": "edit", "text": "Edit", "icon": "mdi-pencil", "color": "primary" },
    'remove'
  ]
}
